import { Router } from '@angular/router';import { UserService } from 'src/app/services/user.service';
import { Component, ViewChild,  TemplateRef } from '@angular/core';
import { CertificadosService } from '../../../services/certificados.service';
import { Corvi } from '../../../models/corvi.model';
import { Validators, FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDialog, getMatFormFieldDuplicatedHintError } from '@angular/material';
import * as moment from 'moment'

declare var jQuery: any;
declare var $: any;
@Component({
    selector: "page-corvi",
    templateUrl: "corvi.component.html",
    styleUrls: ["corvi.component.css"],
    providers: [FormService, CertificadosService]
})

export class CorviComponent{

    public identity;
    public token;
    //@ViewChild('openModal') openModal:TemplateRef<any>;
    public corvi: Corvi;
    public rows = [];
    public actualRow;
    public matcher = new FormService();
    public fecha;
 
    public form;

        constructor(private fb: FormBuilder, private dialog: MatDialog,private _router: Router, private _certService:CertificadosService){
            this.form = new FormGroup({
                fecha: new FormControl(''),
                corvi: new FormControl('')
            
            })
    
            if(!JSON.parse(localStorage.getItem("corvi"))){
                localStorage.setItem("corvi", JSON.stringify(this.rows));
            }else{  
                this.rows = JSON.parse(localStorage.getItem("corvi"));
               // this.form.controls['fecha'].setValue(this.rows[0].fecha?this.rows[0].fecha:'');
               // this.form.controls['corvi'].setValue(this.rows[0].corvi?this.rows[0].corvi:'');
            }
           // this.corvi = {fecha: '',corvi:''};
                            
                    
        }


        ngOnInit() {
            this.get_Corvi();
        }
                  
       
         get_Corvi(){
       
            this._certService.getCorviFM().subscribe(
            response => {
                if(response.message){
                    console.log("No existe corvi registrada a la fecha")
                } else {
                    localStorage.setItem("corvi",JSON.stringify([]));
                    this.form.controls['fecha'].setValue(response.fecha ? moment(response.fecha).format('DD-MM-YYYY') : '')
                    this.form.controls['corvi'].setValue(response.corvi ? response.corvi : '')
                    localStorage.setItem('corvi', JSON.stringify({fecha: response.fecha, corvi:response.corvi}))

              }
             },
            error => {
                console.log(error)
            }
        )
    }




    cleanData(){
        this.corvi = {fecha: '',corvi:''};
    }

    delete_corvi(id){
        for(let x = 0; x < this.rows.length; x++){
            if(id == x){
                this.rows.splice(x, 1);
                localStorage.setItem("corvi", JSON.stringify(this.rows));
            }
        }
    }
}